import "./App.scss";
import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import React, { useCallback, useEffect, useState } from "react";
import PrivateRoutesCheck from "./Utilities/Routes/PrivateRoutes";
import PublicRoutesCheck from "./Utilities/Routes/PublicRoutes";
import { AUTHENTICATION, GLOBAL_CONSTANTS, ROUTES } from "./Constants/Constants";
import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import DashboardLayout from "./Pages/DashBoardLayout/DashboardLayout";
import { ToastContainer } from "react-toast";
import { Toaster } from "react-hot-toast";
import { ProSidebarProvider } from "react-pro-sidebar";
import ProfileLayout from "./Pages/ProfileLayout/ProfileLayout";
import Loader from "./Components/Loader/Loader";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { store } from "./Redux/Store/Store";
import {
  getLanguageJsonArabic,
  getLanguageJsonEnglish,
  setErrorNotification,
  setLanguage,
} from "./Redux/Reducer/Reducer";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { useTranslation } from "react-i18next";
import {
  GetSessionStorageData,
  SetSessionStorageData,
} from "./Utilities/Helpers/Helper";
import ErrorImage from "./Assets/Global/Errorimage.svg";

import HomePage from "./Pages/HomePage/HomePage";
import ThemeParkHomePage from "./Pages/ThemeParkHomePage/ThemeParkHomePage";
import TutorsDashboardLayout from "./Pages/TutorsDashboardLayout/TutorsDashboardLayout";
import TutorsMapsView from "./Pages/TutorsDashboardLayout/TutorsMapsView/TutorsMapsView";
import TutorsDetaileView from "./Pages/TutorsDashboardLayout/TutorsDetaileView/TutorsDetaileView";
import TutorsCalendarView from "./Pages/TutorsDashboardLayout/TutorsCalendarView/TutorsCalendarView";
import TutorsCheckOut from "./Pages/TutorsDashboardLayout/TutorsCheckOut/TutorsCheckOut";
import TutorsPaymentSuccess from "./Pages/TutorsDashboardLayout/TutorsPaymentSuccess/TutorsPaymentSuccess";
import ActivitiesDashboardLayout from "./Pages/ActivitiesDashboardLayout/ActivitiesDashboardLayout";
import ActivitiesMapsView from "./Pages/ActivitiesDashboardLayout/ActivitiesMapsView/ActivitiesMapsView";
import ActivitiesListView from "./Pages/ActivitiesDashboardLayout/ActivitiesListView/ActivitiesListView";
import ActivitiesDetaileView from "./Pages/ActivitiesDashboardLayout/ActivitiesDetaileView/ActivitiesDetaileView";
import ActivitiesCheckOut from "./Pages/ActivitiesDashboardLayout/ActivitiesCheckOut/ActivitiesCheckOut";
import ActivitiesCalendarView from "./Pages/ActivitiesDashboardLayout/ActivitiesCalendarView/ActivitiesCalendarView";
import ActivitiesPaymentSuccess from "./Pages/ActivitiesDashboardLayout/ActivitiesPaymentSuccess/ActivitiesPaymentSuccess";
import UniversityDashboardLayout from "./Pages/UniversityDashboard/UniversityDashboardLayout";
import UniversityMapsView from "./Pages/UniversityDashboard/UniversityMapsView/UniversityMapsView";
import UniversityDetaileView from "./Pages/UniversityDashboard/UniversityDetaileView/UniversityDetaileView";
import UniversityListView from "./Pages/UniversityDashboard/UniversityListView/UniversityListView";
import UniversityChatExpert from "./Pages/UniversityDashboard/UniversityChatExpert/UniversityChatExpert";
import UniversityCheckOut from "./Pages/UniversityDashboard/UniversityCheckOut/UniversityCheckOut";
import UniversityPaymentSuccess from "./Pages/UniversityDashboard/UniversityPaymentSuccess/UniversityPaymentSuccess";
import SchoolDashboardLayout from "./Pages/SchoolDashboardLayout/SchoolDashboardLayout";
import SchoolMapsView from "./Pages/SchoolDashboardLayout/SchoolMapView/SchoolMapView";
import SchoolDetaileView from "./Pages/SchoolDashboardLayout/SchoolDetaileView/SchoolDetaileView";
import SchoolListView from "./Pages/SchoolDashboardLayout/SchoolListView/SchoolListView";
import ThemeParkDasboard from "./Pages/ThemeParkDasboard/ThemeParkDasboard";
import ThemeParkListView from "./Pages/ThemeParkDasboard/ThemeParkListView/ThemeParkListView";
import ThemeParkDetaileView from "./Pages/ThemeParkDasboard/ThemeParkDetaileView/ThemeParkDetaileView";
import ThemeParkCheckOut from "./Pages/ThemeParkDasboard/ThemeParkCheckOut/ThemeParkCheckOut";
import ThemeParkPaymentSucces from "./Pages/ThemeParkDasboard/ThemeParkPaymentSucces/ThemeParkPaymentSucces";
import AddProfile from "./Components/AddProfile/AddProfile";
import EditProfile from "./Components/EditProfile/EditProfile";
import ChildCalender from "./Components/ChildCalender/ChildCalender";
import Favourites from "./Components/Favourites/Favourites";
import NotificationsList from "./Components/NotificationsList/NotificationsList";
import LegalAndSecurity from "./Components/LegalAndSecurity/LegalAndSecurity";
import AboutUS from "./Components/AboutUS/AboutUS";
import PaymentHistory from "./Components/PaymentHistory/PaymentHistory";
import MyWallet from "./Components/MyWallet/MyWallet";
import TutorHubDetailes from "./Components/TutorHubDetailes/TutorHubDetailes";
import MyTickets from "./Components/MyTickets/MyTickets";
import AdminChat from "./Components/AdminChat/AdminChat";
import TutorHub from "./Components/TutorHub/TutorHub";
import MySessions from "./Components/MySessions/MySessions";
import Support from "./Components/Support/Support";
import MyTicketsDetail from "./Components/MyTicketsDetail/MyTicketsDetail";
import SchoolChatExpert from "./Pages/SchoolDashboardLayout/SchoolChatExpert/SchoolChatExpert";
import PreferenceScreen from "./Components/PreferenceScreen/PreferenceScreen";
import AddAddress from "./Components/AddAddress/AddAddress";
import TutorsListView from "./Pages/TutorsDashboardLayout/TutorsListView/TutorsListView";


interface RootState {
  languageReducer: {
    language: string;
    jsonDataEnglish: any;
    jsonDataArabic: any;
  };
  ErrorNotificationReducer?: {
    check: boolean;
    errormessage: string;
  };
}


const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;


i18n
  .use(initReactI18next)
  .init({
    debug: false, 
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: { translation: {} },
      ar: { translation: {} },
    },
  });

function App() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const language = useTypedSelector((state) => state.languageReducer.language);
  const [translationsLoaded, setTranslationsLoaded] = useState(false);

  
  const fetchDataEnglish = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_LABEL_EN_URL}`);
      if (!response.ok) throw new Error("Failed to fetch English translations");
      const data = await response.json();
      store.dispatch(getLanguageJsonEnglish(data));
      i18n.addResourceBundle("en", "translation", data, true, true);

    } catch (error) {
       console.error("Error uploading file:", error);
    }
  };

  
  const fetchDataArabic = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_LABEL_AR_URL}`);
      if (!response.ok) throw new Error("Failed to fetch Arabic translations");
      const data = await response.json();
      store.dispatch(getLanguageJsonArabic(data));
      i18n.addResourceBundle("ar", "translation", data, true, true);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  
  useEffect(() => {
    const loadTranslations = async () => {
      await Promise.all([fetchDataEnglish(), fetchDataArabic()]);
      setTranslationsLoaded(true);
    };
    loadTranslations();
  }, []);

  
  useEffect(() => {
    if (!translationsLoaded) return;
    const storedLang = GetSessionStorageData(AUTHENTICATION.SHARED.LANGUAGE_SWICTH) || "English";
    const langCode = storedLang === "Arabic" ? "ar" : "en";
    i18n.changeLanguage(langCode).then(() => {
      SetSessionStorageData(AUTHENTICATION.SHARED.LANGUAGE_SWICTH, storedLang);
      dispatch(setLanguage(storedLang));

    });
  }, [dispatch, translationsLoaded]);

  
  const routes = [
    {
      path: "",
      element: <Navigate to={ROUTES.HOMEPAGE} />,
    },
    {
      path: "",
      element: <PublicRoutesCheck />,
      children: [
        {
          path: "",
          element: <DashboardLayout />,
          children: [
            { path: ROUTES.HOMEPAGE, element: <HomePage /> },
            { path: ROUTES.THEMEPARK__HOMEPAGE, element: <ThemeParkHomePage /> },
            { path: ROUTES.TUTORS, element: <TutorsDashboardLayout /> },
            { path: ROUTES.TUTORS_MAPS_VIEW, element: <TutorsMapsView /> },
            { path: ROUTES.TUTORS_DETAILE_VIEW, element: <TutorsDetaileView /> },
            { path: ROUTES.TUTORS_LIST_VIEW, element: <TutorsListView /> },
            { path: ROUTES.TUTORS_CALENDAR_VIEW, element: <TutorsCalendarView /> },
            { path: ROUTES.TUTORS_CHECKOUT, element: <TutorsCheckOut /> },
            { path: ROUTES.TUTORS_PAYMENT_SUCCESS, element: <TutorsPaymentSuccess /> },
            { path: ROUTES.ACTIVITYLAYOUT, element: <ActivitiesDashboardLayout /> },
            { path: ROUTES.ACTIVITY_MAPS_VIEW, element: <ActivitiesMapsView /> },
            { path: ROUTES.ACTIVITY_LIST_VIEW, element: <ActivitiesListView /> },
            { path: ROUTES.ACTIVITY_DETAILE_VIEW, element: <ActivitiesDetaileView /> },
            { path: ROUTES.ACTIVITY_CALENDAR_VIEW, element: <ActivitiesCalendarView /> },
            { path: ROUTES.ACTIVITY_CHECKOUT, element: <ActivitiesCheckOut /> },
            { path: ROUTES.ACTIVITY_PAYMENT_SUCCESS, element: <ActivitiesPaymentSuccess /> },
            { path: ROUTES.UNIVERSITYLAYOUT, element: <UniversityDashboardLayout /> },
            { path: ROUTES.UNIVERSITY_MAPS_VIEW, element: <UniversityMapsView /> },
            { path: ROUTES.UNIVERSITY_DETAILE_VIEW, element: <UniversityDetaileView /> },
            { path: ROUTES.UNIVERSITY_LIST_VIEW, element: <UniversityListView /> },
            { path: ROUTES.UNIVERSITY_CHAT_VIEW, element: <UniversityChatExpert /> },
            { path: ROUTES.UNIVERSITY_CHECKOUT, element: <UniversityCheckOut /> },
            { path: ROUTES.UNIVERSITY_PAYMENT_SUCCESS, element: <UniversityPaymentSuccess /> },
            { path: ROUTES.SCHOOLLAYOUT, element: <SchoolDashboardLayout /> },
            { path: ROUTES.SCHOOL_MAPS_VIEW, element: <SchoolMapsView /> },
            { path: ROUTES.SCHOOL_DETAILE_VIEW, element: <SchoolDetaileView /> },
            { path: ROUTES.SCHOOL_LIST_VIEW, element: <SchoolListView /> },
            { path: ROUTES.SCHOOL_CHAT_VIEW, element: <SchoolChatExpert /> },
            { path: ROUTES.THEMEPARK_LAYOUT, element: <ThemeParkDasboard /> },
            { path: ROUTES.THEMEPARK_LIST_VIEW, element: <ThemeParkListView /> },
            { path: ROUTES.THEMEPARK_DETAILE_VIEW, element: <ThemeParkDetaileView /> },
            { path: ROUTES.THEMEPARK_CHECKOUT, element: <ThemeParkCheckOut /> },
            { path: ROUTES.THEMEPARK_PAYMENT_SUCCESS, element: <ThemeParkPaymentSucces /> },
            { path: ROUTES.ABOUTUS_WITHOUT_LOGIN, element: <AboutUS /> },
          ],
        },
      ],
    },
    {
      path: "",
      element: <PrivateRoutesCheck />,
      children: [
        {
          path: "",
          element: <DashboardLayout />,
          children: [
            {
              path: ROUTES.ACCOUNTS,
              element: <ProSidebarProvider><ProfileLayout /></ProSidebarProvider>,
              children: [
                { path: ROUTES.ADD_PROFILE, element: <AddProfile /> },
                { path: ROUTES.EDIT_PROFILE, element: <EditProfile /> },
                { path: ROUTES.CHILDCALENDER, element: <ChildCalender /> },
                { path: ROUTES.FAVOURTIES, element: <Favourites /> },
                { path: ROUTES.ADD_ADDRESS, element: <AddAddress /> },
                { path: ROUTES.MYSESSION, element: <MySessions /> },
                { path: ROUTES.NOTIFICATION, element: <NotificationsList /> },
                { path: ROUTES.LEGALANDSECURITY, element: <LegalAndSecurity /> },
                { path: ROUTES.ABOUTUS, element: <AboutUS /> },
                { path: ROUTES.PREFERENCESCREEN, element: <PreferenceScreen /> },
                { path: ROUTES.SUPPORT, element: <Support /> },
                { path: ROUTES.PAYMENTHISTORY, element: <PaymentHistory /> },
                { path: ROUTES.MYWALLET, element: <MyWallet /> },
                { path: ROUTES.TUTOR_HUB, element: <TutorHub /> },
                { path: ROUTES.TUTOR_HUB_DETAILES, element: <TutorHubDetailes /> },
                { path: ROUTES.MYTICKETS, element: <MyTickets /> },
                { path: ROUTES.MYTICKETS_DETAIL, element: <MyTicketsDetail /> },
                { path: ROUTES.ADMIN_CHAT, element: <AdminChat /> },
              ],
            },
          ],
        },
      ],
    },
    {
      path: "*",
      element: <Navigate to={ROUTES.HOMEPAGE} />,
    },
  ];

  const routers = createBrowserRouter(routes);

  
  const [translateAttribute, setTranslateAttribute] = useState<"yes" | "no" | undefined>("yes");

  useEffect(() => {
    if (language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH) {
      const timer = setTimeout(() => {
        setTranslateAttribute("no");
      }, 1200);
      return () => clearTimeout(timer);
    } else {
      setTranslateAttribute("yes");
    }
  }, [language]);

  
  const [showMobilePopup, setShowMobilePopup] = useState(false);
  const [mobileOS, setMobileOS] = useState<"Android" | "iOS" | "unknown">("unknown");

  const checkMobileAndShowPopup = useCallback(() => {
    const hasSeenPopup = GetSessionStorageData("hasSeenMobilePopup");
    if (hasSeenPopup === "true") return;

    const getMobileOperatingSystem = () => {
      const userAgent = navigator.userAgent || navigator.vendor || "";
      if (/android/i.test(userAgent)) return "Android";
      if (/iPad|iPhone|iPod/.test(userAgent) && !("MSStream" in window)) return "iOS";
      return "unknown";
    };

    const os = getMobileOperatingSystem();
    setMobileOS(os);
    if (os === "Android" || os === "iOS") {
      setShowMobilePopup(true);
      SetSessionStorageData("hasSeenMobilePopup", "true");
    }
  }, []);

  useEffect(() => {
    checkMobileAndShowPopup();
  }, [checkMobileAndShowPopup]);

  const handleRedirectToApp = () => {
    if (mobileOS === "Android") {
      window.location.href = "learnandplay://"
      setTimeout(() => {

      }, 1000);
    } else if (mobileOS === "iOS") {
      window.location.href = "learnandplay://"
      setTimeout(() => {

      }, 1000);
    }
    setShowMobilePopup(false);
  };

  const handleStayOnWeb = () => {
    setShowMobilePopup(false);
  };

  const MobileAppPopup = () => (
    <Dialog open={showMobilePopup} onClose={handleStayOnWeb}>
      <DialogContent>
        <DialogContentText>
          {t("Would you like to switch to Learn & Play mobile app?")}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", fontWeight: "bolder", fontSize: "8px" }}>
        <Button onClick={handleStayOnWeb} color="primary">
          {t("Stay on Website")}
        </Button>
        <Button onClick={handleRedirectToApp} color="primary" autoFocus>
          {t("Open App")}
        </Button>
      </DialogActions>
    </Dialog>
  );

  
  const state = useTypedSelector((state) => state.ErrorNotificationReducer?.check ?? false);
  const errorMessage = useTypedSelector((state) => state.ErrorNotificationReducer?.errormessage ?? "");

  const ErrorNotification = () => {
    const handleClose = () => {
      dispatch(setErrorNotification(false));
    };
    return (
      <Dialog
        open={state}
        onClose={(e, reason) => {
          if (reason === "backdropClick") return;
          handleClose();
        }}
        className="error-popup"
      >
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-12">
              <div className="d-flex flex-column align-items-center text-center">
                <div className="dialog-text">
                  <img src={ErrorImage} alt="errorIcon" className="img-fluid" />
                </div>
                <div className="dialog-text">{t(errorMessage)}</div>
              </div>
              <div className="d-flex justify-content-center mt-3">
                <Button onClick={handleClose} className="close-btn">
                  {t("Close")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    );
  };

  
  if (!translationsLoaded) {
    return <Loader />;
  }

  return (
    <div
      translate={translateAttribute}
      className={
        language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH
          ? "english_container"
          : "arabic_container"
      }
    >
      <Loader />
      <RouterProvider router={routers} />
      <ToastContainer position="bottom-right" delay={4000} />
      <Toaster />
      <MobileAppPopup />
      <ErrorNotification />
    </div>
  );
}

export default App;